import React from "react";

export function VideoIcon() {
  return <i className="fas fa-video"></i>;
}
